import { defError } from "./deferror";
export var UnsupportedOperationError = defError(function () {
  return "unsupported operation";
});
export var unsupported = function unsupported(msg) {
  throw new UnsupportedOperationError(msg);
};